import { rgb } from '../helpers';
import { SKY_BLUE } from '../theme/color';

export const overrides = {
    MuiPaper: {
        elevation1: {
            boxShadow: `0 1px 2px 0 rgba(${rgb(
                SKY_BLUE
            )}, 0.06), 0 2px 4px 0 rgba(${rgb(SKY_BLUE)}, 0.12)`
        }
    }
};
